var module = angular.module('octopusApp.configuration');

module.controller('MaintenanceEditController', function ($scope, $location, busy, octopusRepository, unsavedChanges, $window) {
  var isLoading = $scope.isLoading = busy.create();
  var isSaving = $scope.isSaving = busy.create();

  $scope.status = { ready: false };

  $scope.config = null;
  isLoading.promise(octopusRepository.MaintenanceConfiguration.get().then(function (config) {
    $scope.config = config;

    setTimeout(function () {
      $scope.$apply(function () {
        $scope.status.ready = true;
      });
    }, 100);

  }));

  $scope.save = function() {
    isSaving.promise(octopusRepository.MaintenanceConfiguration.modify($scope.config).then(function (config) {
      unsavedChanges.saved();
      $window.location.reload();
    }));
  };

});


//////////////////
// WEBPACK FOOTER
// ./app/areas/configuration/maintenance/controllers/maintenance_edit_controller.js
// module id = 393
// module chunks = 1